import React, {
  useEffect,
  useState,
} from 'react';
import {
  MediaCategory,
  MultimediaType,
} from 'pages/Dashboard/utils/constants';
import MultiMediaList from 'pages/Dashboard/components/MultimediaList';
import {
  PatientMetaDataProps,
} from 'pages/Dashboard/pages/Encounters/pages/List/types/patientMetaData';
import MediaListSkeleton from 'pages/Dashboard/pages/Encounters/pages/List/components/PatientDetails/MediaListSkeleton';
import {
  useGetPatientMediaByMultimediaTypeWithPagination,
} from 'pages/Dashboard/hooks/useGetPatientMediaByMultimediaType';
import {
  PatientDetailsTab,
} from 'pages/Dashboard/pages/Encounters/pages/List/components/PatientDetails';
import Pagination from 'core/components/VirtualTable/Pagination';

const DEFAULT_PAGE_SIZE = 25;

export type MediaInfo = {
  multimediaTypes?: MultimediaType[];
  mediaCategory?: MediaCategory;
};

const labelByType: Record<PatientDetailsTab, string> = {
  imaging: 'Images',
  report: 'Lab Reports',
  notes: 'Notes',
};

const mediaTypeMap: Record<PatientDetailsTab, MediaInfo> = {
  imaging: {
    multimediaTypes: [MultimediaType.RadiologyImages],
  },
  report: {
    mediaCategory: MediaCategory.Report,
  },
  notes: {
    multimediaTypes: [
      MultimediaType.MedicalNotes,
      MultimediaType.OtherProviderNote,
    ],
  },
};

export default function MediaContents({ encounter, type }: PatientMetaDataProps) {
  const mediaType = mediaTypeMap[type];
  const [page, setPage] = useState(0);

  const {
    data,
    isLoading,
  } = useGetPatientMediaByMultimediaTypeWithPagination(
    encounter?.patient?.patientId ?? 0,
    mediaType,
    true,
    page,
    DEFAULT_PAGE_SIZE,
  );

  useEffect(() => {
    setPage(0);
  }, [type, encounter?.patient?.patientId]);

  const mediaList = (data ?? {})?.list ?? [];
  const { totalSize = 0 } = (data ?? {})?.pageProperties ?? {};

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      {isLoading && <MediaListSkeleton className="px-4" />}
      {mediaList.length > 0 && (
        <div className="flex flex-col gap-2 justify-between h-full overflow-hidden">
          <MultiMediaList data={mediaList ?? []} className="overflow-y-auto flex-1 px-4" />
          <Pagination
            pageIndex={page}
            pageSize={DEFAULT_PAGE_SIZE}
            setPageIndex={setPage}
            totalItems={totalSize}
            classes={{
              root: 'items-center py-1',
              pageSizeSelector: '!hidden',
              pageInfo: 'flex flex-row items-center justify-between !w-full',
            }}
          />
        </div>
      )}
      {((data?.list ?? []).length === 0) && !isLoading && (
        <span className="text-xs text-gray-light px-4">
          No
          {' '}
          {labelByType[type]}
        </span>
      )}
    </div>
  );
}
